<template>
  <div style="margin-top: 1em; text-align: center">
    <div style="color: var(--neutral-0); font-size: 14px; font-weight: 300">
      {{ $t("message.tapAState") }}
    </div>
    <div class="legend-item-wrapper">
      <div class="legend-item">
        <svg
          height="10"
          width="28">
          <pattern
            id="legend-pattern"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45 2 2)"
            width="8"
            height="8">
            <rect
              width="8"
              height="8"
              fill="#666666"
              opacity="0.8" />

            <path
              d="M 0 0 L 0 10"
              stroke="#666666"
              stroke-width="10" />
          </pattern>

          <rect
            height="10"
            width="28"
            fill="url(#legend-pattern)" />
        </svg>

        <span class="legend-text">{{ $t("message.leading") }}</span>
      </div>
    </div>
    <div class="legend-item-wrapper">
      <div class="legend-item">
        <svg
          height="10"
          width="28">
          <rect
            height="10"
            width="28"
            fill="#666666" />
        </svg>

        <span class="legend-text">{{ $t("message.won") }}</span>
      </div>
    </div>

    <div class="legend-item-wrapper">
      <div class="legend-item">
        <svg
          height="10"
          width="28">
          <rect
            height="10"
            width="28"
            fill="#bdbdbd" />
        </svg>

        <span class="legend-text">{{ $t("message.noResults") }}</span>
      </div>
    </div>

    <div
      v-if="showRunoff"
      class="legend-item-wrapper">
      <div class="legend-item">
        <svg
          height="10"
          width="28">
          <pattern
            id="runoff-pattern"
            patternUnits="userSpaceOnUse"
            width="12"
            height="12">
            <rect
              width="12"
              height="12"
              fill="#bdbdbd" />

            <rect
              width="4"
              height="12"
              fill="var(--dem-color)"
              x="0"
              y="0" />

            <rect
              width="4"
              height="12"
              fill="var(--gop-color)"
              x="8"
              y="0" />
          </pattern>

          <rect
            height="10"
            width="28"
            fill="url(#runoff-pattern)" />
        </svg>

        <span class="legend-text">{{ $t("message.runoff") }}</span>
      </div>
    </div>
  </div>
</template>
<script>
const props = {
  showRunoff: {
    type: Boolean,
    required: false,
  },
};

export default {
  props,
};
</script>

<style>
.legend-item-wrapper {
  display: inline-block;
  margin: 4px 6px;
}

.legend-item {
  display: flex;
  align-items: center;
}

.legend-text {
  font-size: 13px;
  font-weight: 300;
  color: var(--neutral-0);
  margin-left: 2px;
  padding-left: 3px;
}
</style>
